import { IStorageService } from '../interfaces/IStorageService';
import { logger } from 'src/utils/logger';

/**
 * 本地存储服务实现
 */
export class LocalStorageService extends IStorageService {
  save(key, value) {
    try {
      const serializedValue = typeof value === 'string' ? value : JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
      logger.debug(`[LocalStorageService] 保存数据: ${key}`, value);
    } catch (error) {
      logger.error(`[LocalStorageService] 保存数据失败: ${key}`, error);
      throw error;
    }
  }

  get(key) {
    try {
      const value = localStorage.getItem(key);
      if (value === null) return null;

      try {
        return JSON.parse(value);
      } catch {
        return value;
      }
    } catch (error) {
      logger.error(`[LocalStorageService] 获取数据失败: ${key}`, error);
      return null;
    }
  }

  remove(key) {
    try {
      localStorage.removeItem(key);
      logger.debug(`[LocalStorageService] 删除数据: ${key}`);
    } catch (error) {
      logger.error(`[LocalStorageService] 删除数据失败: ${key}`, error);
    }
  }
}
